<div class="mx-4 flex items-center gap-2 font-black">
	<svg
		width="32"
		height="32"
		viewBox="0 0 1024 1024"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="256" y="670.72" width="512" height="256" rx="128" class="fill-base-content" />
		<circle cx="512" cy="353.28" r="256" class="fill-base-content" />
		<circle cx="512" cy="353.28" r="261" stroke="black" stroke-opacity="0.2" stroke-width="10" />
		<circle cx="512" cy="353.28" r="114.688" class="fill-base-100" />
	</svg>

	<div>
		Setter<span class="text-primary">AI</span>
	</div>

	<!-- <div class="badge badge-accent font-medium badge-xs">PRO</div> -->
</div>
